import Ripple from './Ripple';

export * from './Ripple';
export default Ripple;
